import { createApp } from 'vue';
import './style.css';
import App from './App.vue';

import router from './router';
import { format } from 'date-fns';

import {createPinia } from 'pinia';

import i18n from './i18n.ts';

import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/controls/dist/style.css'
import '@vue-flow/minimap/dist/style.css'
import 'devicon/devicon.min.css'

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

import mitt from 'mitt';

library.add(fas, fab, far);

const emitter = mitt();

const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const user= JSON.parse(localStorage.getItem('user') || 'null')
    //console.log("user preferredLanguage", user?.preferredLanguage );
    const strFormat = user?.preferredLanguage === 'enUs' ? "MM/dd/yyyy HH:mm:ss" : "dd/MM/yyyy HH:mm:ss";
    return format(date, strFormat);
};

export const app =createApp(App).use(router).use(i18n);

app.component('font-awesome-icon', FontAwesomeIcon);

app.use(createPinia());

app.config.globalProperties.$formatDate = formatDate;

app.provide('emitter', emitter);

app.mount('#app');

console.log(import.meta.env);